import { jsx as _jsx } from "react/jsx-runtime";
var Mark;
(function (Mark) {
    Mark[Mark["Bold"] = 1] = "Bold";
    Mark[Mark["Italic"] = 2] = "Italic";
    Mark[Mark["Strikethrough"] = 4] = "Strikethrough";
    Mark[Mark["Underline"] = 8] = "Underline";
    Mark[Mark["Code"] = 16] = "Code";
    Mark[Mark["Subscript"] = 32] = "Subscript";
    Mark[Mark["Superscript"] = 64] = "Superscript"; // 64
})(Mark || (Mark = {}));
const defaultRenderers = {
    [Mark.Superscript]: (c) => _jsx("sup", { children: c }),
    [Mark.Subscript]: (c) => _jsx("sub", { children: c }),
    [Mark.Code]: (c) => _jsx("code", { children: c }),
    [Mark.Underline]: (c) => (_jsx("span", { style: { textDecoration: "underline" }, children: c })),
    [Mark.Strikethrough]: (c) => _jsx("s", { children: c }),
    [Mark.Italic]: (c) => _jsx("em", { children: c }),
    [Mark.Bold]: (c) => _jsx("strong", { children: c })
};
const optionRenderers = (opts) => ({
    [Mark.Superscript]: opts?.superscript,
    [Mark.Subscript]: opts?.subscript,
    [Mark.Code]: opts?.code,
    [Mark.Underline]: opts?.underline,
    [Mark.Strikethrough]: opts?.strikethrough,
    [Mark.Italic]: opts?.emphasis,
    [Mark.Bold]: opts?.strong
});
const buildRenderers = (opts) => {
    const merged = { ...defaultRenderers };
    Object.entries(optionRenderers(opts)).forEach(([k, fn]) => {
        if (typeof fn === "function") {
            merged[k] = fn;
        }
    });
    return merged;
};
// Convert "\n" → ReactNodes with <br/>
const withLineBreaks = (raw) => raw.split("\n").reduce((acc, part, idx) => {
    if (idx > 0) {
        acc.push(_jsx("br", {}, `br-${idx}`));
    }
    acc.push(part);
    return acc;
}, []);
export const Text = ({ data, options, style, wrapTextInSpan }) => {
    const { textFormat, text: rawText } = data;
    if (!rawText) {
        return null;
    }
    const initial = withLineBreaks(rawText);
    const renderers = buildRenderers(options);
    const order = [
        Mark.Superscript,
        Mark.Subscript,
        Mark.Code,
        Mark.Underline,
        Mark.Strikethrough,
        Mark.Italic,
        Mark.Bold
    ];
    let content = initial;
    order.forEach((mark) => {
        if (textFormat & mark) {
            content = renderers[mark](content, style);
        }
    });
    return options?.normal ? (options.normal(content, style)) : wrapTextInSpan ? (_jsx("span", { children: content })) : (content);
};
